import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { getSocialColor, getSocialIcon } from '@change-corgi/design-system-legacy/components/social';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading } from '@change-corgi/design-system-legacy/typography';

import type { RedditShareRecommendations } from '../../hooks/useFetchShareRecommendations';

import { SubredditCard } from './components/SubredditCard';
import { useSortedRecommendations } from './hooks/useSortedRecommendations';

type Props = {
	shareRecommendations: RedditShareRecommendations;
};

export function RedditSubredditsVariant({ shareRecommendations }: Props): JSX.Element | null {
	const {
		data: { sortedRecommendations },
	} = useSortedRecommendations(shareRecommendations);

	if (sortedRecommendations.length === 0) {
		return null;
	}

	return (
		<Flex sx={{ flexDirection: 'column', gap: 16, flexBasis: ['auto', '430px'] }}>
			<Heading
				as="h3"
				size="h4"
				sx={{ display: 'flex', gap: 10, flexGrow: 0, alignItems: 'center' }}
				id="reddit-recommendations-title"
				data-qa="recommendations-title"
				tabIndex={0}
				aria-label="Recommended Subreddits"
			>
				<Icon
					icon={getSocialIcon('reddit')}
					size={32}
					backgroundColor={getSocialColor('reddit')}
					color="white"
					sx={{ borderRadius: '50%' }}
				/>
				<Translate value="corgi.petition.starter_dashboard.recommendations.reddit.title" />
			</Heading>
			<Flex sx={{ flexDirection: 'column', gap: 16 }} data-testid="reddit-subreddits-list">
				{sortedRecommendations.map((subreddit) => (
					<SubredditCard recommendation={subreddit} key={subreddit.url} />
				))}
			</Flex>
		</Flex>
	);
}
